import { HotspotTypeEnum } from './hotspot.types.enum';
import { HotspotThemesEnum } from './hotspot.themes.enum';


export class HotspotModel {
  // positioning ================================================
  pos?: [number, number, number];
  primitiveIndex?: number;
  barycentric?: [number, number, number];
  renderableIndex?: number;
  dir: [number, number, number];
  objectId: string;
  
  // styling ====================================================
  shown: boolean;
  type: HotspotTypeEnum;
  symbol: string;
  className: string; // e.g. "circle minus label"
  theme?: HotspotThemesEnum;

  // actions ===================================================
  actionSrc?: string;
  actions?: string[];

  // label properties ==========================================
  title?: string;
  description?: string;
  labelOffset?: [number, number];

}
